import React from 'react';
import radium from 'radium';
import {ThemeContext} from "../../../components/theme/Theme.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Toggler(props) {
	const context = React.useContext(ThemeContext);
	// Styles
	const style = {
		toggleDiv: {
			backgroundColor: context.themeManager.value('category-dropdown',
				'color', 'bg-color-dropdown-toggle'),
			display: 'flex',
			height: '2em',
			width: '10em',
			maxWidth: '60%',
			justifyContent: 'center',
			margin: 'auto',
			color: context.themeManager.value('category-dropdown',
				'color', 'color-dropdown-toggle'),
			alignItems: 'center',
			zIndex: '20',
			fontWeight: '300',
			cursor: 'pointer',
		},
		toggleIcon: {
			color: context.themeManager.value('category-dropdown',
				'color', 'fg-color-dropdown-toggle-icon'),
			fontSize: '1em',
			padding: '0 0 0 0.5em',
		},
	};

	return (
		<button className={"leo__button-sample"} id="category-button" aria-controls="category-list" aria-haspopup="true" aria-expanded={props.showContent} style={style.toggleDiv} onClick={props.onClick} >
			Kategorien
			<FontAwesomeIcon
				icon={props.showContent ? 'angle-double-up' : 'angle-double-down'}
				style={style.toggleIcon}
			/>
		</button>
	);
}

export default radium(Toggler);
